module.exports = __webpack_public_path__ + "img/qk-df-en.9e9ad03d.png";